import { SignIn, SignUp } from "@clerk/react";

const Panel = () => (
  <div className="hidden lg:flex relative w-1/2 bg-stone-200 overflow-hidden">
    <img src="/img/login-bg.jpg" alt="" className="absolute inset-0 h-full w-full object-cover" />
    <div className="absolute inset-0 bg-stone-900/30" />
    <div className="relative mt-auto p-12 text-white">
      <p className="text-xs font-bold uppercase tracking-[0.2em]">Sehatic-Pedia</p>
      <h1 className="font-heading text-5xl font-black tracking-tight mt-3 leading-tight">Plateforme<br />d'administration</h1>
      <p className="mt-4 text-sm text-white/90 max-w-sm">Gérez les utilisateurs, praticiens, contenus et rendez-vous de l'application mobile.</p>
    </div>
  </div>
);

export default function AuthPage({ mode }) {
  return (
    <div className="min-h-screen flex bg-[#F5F5F4]" data-testid={`auth-page-${mode}`}>
      <Panel />
      <div className="flex-1 flex flex-col items-center justify-center p-4 sm:p-8">
        <p className="lg:hidden font-heading text-2xl font-black tracking-tight text-stone-900 mb-6">Sehatic-Pedia Admin</p>
        {mode === "sign-in"
          ? <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp />
          : <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />}
      </div>
    </div>
  );
}
